'use client';

import { useEffect } from 'react';
import { reportClientError } from '@/lib/report-client-error';

// Group-level backstop for the (public) routes (deeper /games and
// /game/[id] boundaries catch first). Renders inside (public)/layout.tsx so
// the WebSocket the layout owns survives a page-level crash.
export default function PublicError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): JSX.Element {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('public route error', error);
    reportClientError(error);
  }, [error]);
  return (
    <section className="mx-auto max-w-md border border-border rounded-lg bg-panel p-6 text-sm">
      <h2 className="text-base font-semibold text-err">Something went wrong</h2>
      <p className="mt-2 text-muted">
        We couldn&apos;t render this page. The executor may be temporarily unreachable — try
        again.
      </p>
      {error.digest ? (
        <p className="mt-2 text-[10px] text-muted">Error ID: {error.digest}</p>
      ) : null}
      <button
        onClick={reset}
        className="mt-4 rounded-md border border-accent px-3 py-1 text-xs text-accent hover:bg-accent/10"
      >
        Try again
      </button>
    </section>
  );
}
